// src/components/report_details/DomainDataSection.tsx
import React, { useState, useEffect } from 'react';
import Emails from './Emails/Emails';
import IPs from './IPs/IPs';
import SpoofOrNot from './spoofornot/SpoofOrNot';
import Typosquatting from './Typosquatting/Typosquatting';
import Subdomains from './Subdomains/Subdomains';
import NamesTld from './Namestld/NamesTld';

import { DomainDetails, EmailDetail, IPDetail, IPInfoResponse, LeakData, SpoofornotDetail, Subdomain, TyposquattingDetail, WhoisInfoDetail } from '../../types/interfaces';
import LeaksInfo from './Leaks/LeaksInfo';
import { IPInfoSection } from './IPInfoSection/IPInfoSection';
import WhoisInfoSection from './Whois/WhoisInfoSection';

interface DomainObject {
  id: number;
  domain_name: string;
}

interface DomainDataSectionProps {
  domainObjects: DomainObject[]; 
  domainDetails: { [domainName: string]: DomainDetails };
}

const DomainDataSection: React.FC<DomainDataSectionProps> = ({
  domainObjects,
  domainDetails
}) => {
  // Estado para manejar el dominio seleccionado
  const [selectedDomain, setSelectedDomain] = useState<string | null>(null);

  useEffect(() => {
    if (domainObjects.length > 0 && !selectedDomain) {
      setSelectedDomain(domainObjects[0].domain_name);
    }
  }, [domainObjects, selectedDomain]);

  // Si todavía no hay dominio seleccionado, no renderizamos nada
  if (!selectedDomain) {
    return null; 
  }

  // Sacamos los datos de domainDetails para el dominio actual
  const currentDetail: DomainDetails = domainDetails[selectedDomain] || {} as DomainDetails;

  const emailsData: EmailDetail[] = currentDetail.emails || [];
  const ipsData: IPDetail[] = currentDetail.ips || [];

  // Nuevos apartados
  const leaksData: LeakData[] = currentDetail.leaks || [];
  const ipInfoList: IPInfoResponse[] = currentDetail.ipinfo ?? [];
  const spoofornotData: SpoofornotDetail | undefined = currentDetail.spoofornot;
  const typosquattingData: TyposquattingDetail[] = currentDetail.typosquatting || [];
  const subdomainsData: Subdomain[] = currentDetail.subdomains || [];
  const namesTldData: any[] = currentDetail.names_tld || [];
  const whoisData: WhoisInfoDetail | null | undefined = currentDetail.whois;

  // Manejador de cambio de dominio
  const handleDomainChange = (domain: string) => {
    setSelectedDomain(domain);
  };

  return (
    <div className="mt-6 space-y-6">
      <LeaksInfo
        selectedDomain={selectedDomain}
        leaksData={leaksData}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
      />

      {/* Emails */}
      <Emails
        selectedDomain={selectedDomain}
        emailsData={emailsData}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
      />

       <WhoisInfoSection
        domains={domainObjects}
        selectedDomain={selectedDomain}
        onDomainChange={handleDomainChange}
        whois={whoisData}
      />
      
      <SpoofOrNot
        selectedDomain={selectedDomain}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
        spoofornotData={spoofornotData} 
      />

      {/* Typosquatting */}
      <Typosquatting
        selectedDomain={selectedDomain}
        typosquattingData={typosquattingData}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
      />

      {/* NamesTld */}
      <NamesTld
        selectedDomain={selectedDomain}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
        namesTldData={namesTldData}
      />

      <IPInfoSection
        domains={domainObjects.map(d => d.domain_name)}
        selectedDomain={selectedDomain}
        onDomainChange={handleDomainChange}
        ipInfoList={ipInfoList}
      />

      {/* IPs */}
      <IPs
        selectedDomain={selectedDomain}
        ipsData={ipsData}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
      />

      {/* Subdomains */}
      <Subdomains
        selectedDomain={selectedDomain}
        subdomainsData={subdomainsData}
        domains={domainObjects}
        onDomainChange={handleDomainChange}
      />
    </div>
  );
};

export default DomainDataSection;
